import React, { useContext } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { Context } from '../index';
import { authRoutes, publicRoutes, SHOP_ROUTE } from '../routes';
import AdminRoute from './ProtectedRoute';

const AppRouter = () => {
    const { user } = useContext(Context);
    const isAuth = user.isAuth;

    return (
        <Routes>
            {/* Публичные маршруты */}
            {publicRoutes.map(({ path, Component }) => (
                <Route key={path} path={path} element={<Component />} />
            ))}

            {/* Защищенные маршруты */}
            {isAuth && authRoutes.map(({ path, Component, requiresAdmin }) => {
                if (requiresAdmin) {
                    return (
                        <Route 
                            key={path} 
                            path={path} 
                            element={
                                <AdminRoute>
                                    <Component />
                                </AdminRoute>
                            } 
                        />
                    );
                }
                return (
                    <Route key={path} path={path} element={<Component />} />
                );
            })}

            {/* Редирект на главную */}
            <Route path="*" element={<Navigate to={SHOP_ROUTE} />} />
        </Routes>
    );
};

export default observer(AppRouter);